import { FC, PropsWithChildren, useReducer } from 'react';
import { Store, initialRootState } from './context';
import rootReducer from './reducers';

const StoreProvider: FC<PropsWithChildren> = ({ children }) => {
    const [state, dispatch] = useReducer(rootReducer, initialRootState);
    return <Store.Provider value={{ dispatch, state }}>{children}</Store.Provider>;
};

export default StoreProvider;
